import "./scss/index.scss";
import { RichText } from "prismic-reactjs";
import React from "react";
import { SliceProductDetailsAccordion } from "./SliceProductDetailsAccordion";
export function SliceProductDetails(_ref) {
  var primary = _ref.primary,
      fields = _ref.fields;
  return React.createElement("div", {
    className: "slice-product-details"
  }, React.createElement("div", {
    className: "container padding-left"
  }, primary.title && React.createElement("div", {
    className: "page-title blue"
  }, React.createElement(RichText, {
    render: primary.title
  })), fields && React.createElement("ul", {
    className: "slice-product-details__list"
  }, fields.map(function (item, i) {
    return React.createElement("li", {
      key: i
    }, React.createElement(SliceProductDetailsAccordion, {
      item: item,
      key: i
    }));
  }))));
}
SliceProductDetails.componentName = "product_details";
export default SliceProductDetails;